import React, { useEffect, useState } from 'react';
import { CheckIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export const PricingSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const element = document.getElementById('pricing');
      if (element) {
        const position = element.getBoundingClientRect();
        if (position.top < window.innerHeight * 0.75) {
          setIsVisible(true);
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check on initial load
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const features = ['Unlimited student management', 'Lesson scheduling & calendar integration', 'Secure teacher account', 'Studio & lesson management tools', 'Revenue tracking & reporting', 'Dedicated support'];
  return <section id="pricing" className="py-24 bg-white" data-id="element-10624">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-10625">
        <div className="text-center mb-16" data-id="element-10626">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy-900 mb-4" data-id="element-10627">
            Simple Pricing for Teachers
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-10628">
            Affordable monthly subscription with no hidden fees or commission on
            your lessons.
          </p>
        </div>
        <div className="max-w-lg mx-auto" data-id="element-10629">
          <div className={`transition-all duration-700 ${isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`} data-id="element-10630">
            <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-100" data-id="element-10631">
              <div className="bg-navy-800 text-white p-8 text-center" data-id="element-10632">
                <h3 className="text-2xl font-bold mb-2" data-id="element-10633">
                  Teacher Subscription
                </h3>
                <div className="flex justify-center items-baseline my-4" data-id="element-10634">
                  <span className="text-5xl font-bold" data-id="element-10635">$9.99</span>
                  <span className="text-xl text-gray-300 ml-1" data-id="element-10636">/month</span>
                </div>
                <p className="text-sm text-gray-400 mb-2" data-id="element-10637">
                  Early Teacher Access — Marketplace features coming later
                </p>
              </div>
              <div className="p-8" data-id="element-10638">
                <ul className="space-y-4 mb-8" data-id="element-10639">
                  {features.map((feature, index) => <li key={index} className="flex items-start" data-id="element-10640">
                      <div className="flex-shrink-0" data-id="element-10641">
                        <CheckIcon className="h-5 w-5 text-navy-800" data-id="element-10642" />
                      </div>
                      <p className="ml-3 text-gray-700" data-id="element-10643">{feature}</p>
                    </li>)}
                </ul>
                <Link to="/teacher-signup" className="block w-full bg-navy-800 hover:bg-navy-900 text-white font-medium py-3 px-4 rounded-lg transition-colors text-center" onClick={() => {
                // Ensure we scroll to top when navigating
                setTimeout(() => {
                  window.scrollTo(0, 0);
                }, 100);
              }} data-id="element-10644">
                  Start Free
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};